import React from 'react';
import PropTypes from 'prop-types';
import { POPUP, POPUPS } from 'utils/constants/popup';
import PopupV1 from 'new-ui/Components/Popup';
import { PopupV2 } from 'new-ui/Components/PopupV2/PopupV2';
import {
  POPUP_COMPONENT_BY_POPUP, V1_POPUP_VERSION, V2_POPUP_VERSION, V3_POPUP_VERSION,
} from './constants';

const POPUP_VERSION_BY_POPUP = {
  [POPUP.CALLUS]: V2_POPUP_VERSION,
  [POPUP.NBA_CHAT]: V3_POPUP_VERSION,
};

const POPUPS_PARAMS = {
  [POPUP.NEXT_APPOINTMENT]: { isFullHeight: true },
  [POPUP.PHONE_IS_ALREADY_USED]: { theme: 'middle' },
  [POPUP.ASSISTANCE_CHAT]: { isOverlayShown: false },
  [POPUP.CHECK_CURRENT_USER_TRIAL_ELIGIBILITY]: { isHeaderShown: false, isFullWidth: true },
};

const getPopupContent = ({ popupEntry, closePopup }) => {
  if (!popupEntry) {
    return null;
  }
  const PopupContent = POPUP_COMPONENT_BY_POPUP[popupEntry.type];
  const data = popupEntry.data || {};
  return <PopupContent closePopup={closePopup} {...data} />;
};

const getPopupVersion = (type) => {
  if (!type || !POPUPS.includes(type)) {
    return null;
  }
  return POPUP_VERSION_BY_POPUP[type] ?? V1_POPUP_VERSION;
};

const getV1PopupProps = ({ popupType, popupData }) => {
  const {
    theme, autoWidth, skipClose, isFullScreen,
  } = popupData ?? {};
  return {
    ...(POPUPS_PARAMS[popupType] ?? {}), theme, autoWidth, skipClose, isFullScreen,
  };
};

export const PopupVersion = ({
  closePopup,
  isMain,
  isTop,
  zIndex,
  popupEntry,
}) => {
  const { type: popupType, data: popupData } = popupEntry ?? {};
  const version = popupType && getPopupVersion(popupType);

  const popupV1Params = version === V1_POPUP_VERSION ? getV1PopupProps({ popupType, popupData }) : {};

  // it is expected that PopupV1 is rendered all the time even if no one popup is shown
  // this is required for the appearance/disappearance animation to work
  return (
    <>
      {version === V3_POPUP_VERSION && (
        getPopupContent({ popupEntry, closePopup })
      )}
      {version === V2_POPUP_VERSION && (
        <PopupV2 key={popupType} type={popupType} closePopup={closePopup} data={popupData} />
      )}
      <PopupV1
        isMain={isMain}
        isTop={isTop}
        zIndex={zIndex}
        closePopup={closePopup}
        isVisible={version === V1_POPUP_VERSION}
        popupData={popupData}
        className={popupType}
        {...popupV1Params}
      >
        {version === V1_POPUP_VERSION ? getPopupContent({ popupEntry, closePopup }) : null}
      </PopupV1>
    </>
  );
};

PopupVersion.propTypes = {
  popupEntry: PropTypes.shape({
    type: PropTypes.string.isRequired,
    data: PropTypes.shape({
      theme: PropTypes.string,
      autoWidth: PropTypes.bool,
      skipClose: PropTypes.bool,
      isFullScreen: PropTypes.bool,
    }),
  }),
  closePopup: PropTypes.func.isRequired,
  isMain: PropTypes.bool.isRequired,
  isTop: PropTypes.bool.isRequired,
  zIndex: PropTypes.number.isRequired,
};
